import styled from 'styled-components';
import { MediaQuery } from 'octa-front-sdk';
import Color from 'octa-front-sdk/dist/enums/Color';
import FontSize from 'octa-front-sdk/dist/enums/FontSize';

import BtnWithLoadStyle from '../../../BtnWithLoad/styles';

export const NotServedWarning = styled.div`
  > * {
    display: block;
  }

  > span {
    font-size: 1.15rem;
    width: 97%;
    padding: 10px;
    color: ${Color.Yellow900};
    border: 1px solid ${Color.Yellow700};
    background-color: ${Color.Yellow200};
    border-radius: 8px;
    margin-bottom: 0.4rem;
  }

  > button {
    cursor: pointer;
    transition: 200ms;
    width: 50%;
    margin: 0 auto;
    padding: 1rem;
    border: none;
    border-radius: 8px;
    background-color: ${Color.MeuDeliveryCyan};
    color: ${Color.White};

    &:hover {
      filter: brightness(0.9);
    }
  }
`;

export const Names = styled.div`
  display: flex;
  border-radius: 20px;
  border: 1px solid ${Color.Grey400};
  margin-bottom: 40px;
  overflow: hidden;

  & > div {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    cursor: pointer;

    &:not(:last-of-type) {
      border-right: 1px solid ${Color.Grey400};
    }

    &,
    span {
      color: ${Color.Grey400};
    }

    svg {
      margin-bottom: 10px;
    }

    &.active {
      span,
      svg {
        color: ${Color.MeuDeliveryCyan};
      }
    }

    ${MediaQuery.BiggerThanSmall} {
      span {
        font-size: ${FontSize.NormalX};
      }
    }
  }
`;

export const Container = styled.div`
  form {
    .form-line {
      display: flex;
      gap: 8px;

      div {
        flex: 1;
      }
    }

    .state-line {
      div:last-child {
        flex: 3;
      }
    }

    .submit-btn {
      margin-bottom: 1rem;
    }

    .delete-btn,
    .loading-btn {
      background-color: #fff;
      color: ${Color.Red500};
      border: 1px solid ${Color.Red500};
    }
  }

  ${MediaQuery.SmallerThanSmall} {
    form {
      .form-line {
        display: block;
      }
    }
  }
`;
